import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type {
  SingleSparkRunRecommendationResponse,
  SparkRunRecommendationAttributes,
} from 'types/Spark/SparkRunRecommendations';
import { CACHE_AND_STALE_TIME } from 'constants/index';

type MutationVariables = Partial<SparkRunRecommendationAttributes>;

export function useSparkRunRecommendations(
  sparkID: string,
  workspaceID: string
) {
  const addSparkRunRecommendation = (recommendation: MutationVariables) => {
    if (!recommendation.sparkID) {
      return Promise.reject('Spark ID cannot be null');
    }
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.SPARK_RUN_RECOMMENDATIONS,
        attributes: {
          sparkRunRecommendationStatusTypeID: 0,
          ...recommendation,
        },
      },
    };

    return fetchWrapper<SingleSparkRunRecommendationResponse>({
      url: SPARK_RESOURCE_TYPES.SPARK_RUN_RECOMMENDATIONS,
      method: 'POST',
      body: body,
    });
  };
  return useQuery(
    ['sparkRunRecommendation', sparkID],
    () => addSparkRunRecommendation({ sparkID, workspaceID }),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `Failed to post Spark Run Recommendation: ${error.message}`
          );
        }
      },
      // this will be handle using refetch
      enabled: false,
      ...CACHE_AND_STALE_TIME,
    }
  );
}
